import { APILoggerDetail, buildAPILoggerDetail } from '../../models/APILoggerDetail';
import { GraphTemplate, graphTemplateModel, GraphSettings, deepCopyAshridgeDefault, APIGraphTemplate } from '../../models/GraphTemplateModel'
import { CreateUrl, CallGetAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import { APIGetLoggerReadingsModel, buildAPIGetLoggerReadingsModel } from '../../models/APIGetLoggerReadingsModel';
import moment from 'moment'
import { decodeFlowMultiplier } from 'Utils/FlowMultiplier';
import { adjustTime } from '../../Utils/AdjustTime'
import { flowConverter, pressureConverter, totalConverter } from '../../Utils/UnitConverters'
export interface SiteDetails {
    siteName: string
    siteRef: string
    serial: number | null

}

export interface Readings extends Record<string, any> {
    date: Date;
    ChannelLetter: string
    serial: string
}

export interface PreviousValueArray {
    serial: number | null
    value: number | null
    isZero: boolean

}




export const findMissingKeys = (savedTemplate: GraphSettings, defaultTemplate: GraphSettings): GraphSettings => {

    const defaultKeys = Object.keys(defaultTemplate)
    const missingKeys = (Object.keys(defaultTemplate) as (keyof GraphSettings)[]).filter(key => !Object.keys(savedTemplate).includes(key))


    if (missingKeys.length > 0) {
        missingKeys.forEach(missing => {
            savedTemplate[missing] = defaultKeys[missing]
        })
    }
    for (const key in savedTemplate) {

        if (savedTemplate[key] === undefined) {
            savedTemplate[key] = defaultTemplate[key]
        }

    }

    return savedTemplate
}

const getLoggingIntervalsForLoggers = (startDate: Date, endDate :Date, loggerDataArray: APILoggerDetail[]):void => {
    interface LoggerItem {
        id: number
    }

    console.log(loggerDataArray)

    let loggers: Array<LoggerItem> = [];
    if (loggerDataArray && loggerDataArray.length > 0) {
        loggers = loggerDataArray.map((item: APILoggerDetail) => {
            return { id: item.LoggerId };
        });
    }
    console.log(loggers)

    const requestOptions = {
        // Your existing request options here
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            startDate: moment(startDate).format("YYYY-MM-DD HH:mm:ss"),
            endDate: moment(endDate).format("YYYY-MM-DD HH:mm:ss"),
            loggers: loggers,
            model: false,
            deployed: false,
            siteName: false,
            siteRef: false,
            deviceSiteName: false,
            gps: false,
            energyLevel: false,
            coverageClass: false,
            actType: false,
            transmissionsPerDay: false,
            dataConnectionsMade: false,
            batteryVoltage: false,
            lastStatusMessage: false,
            lastDataPoint: false,
            lastMessageType: false,
            relayStatus: false,
            lastConnection: false,
            currentSignal: false,
            firmware: false,
            batteryPer: false,
            batterySaverPer: false,
            batteryLife: false,
            minFlowAL: false,
            maxFlowAL: false,
            avgFlowAL: false,
            consumptionAL: false,
            minFlowAM3: false,
            maxFlowAM3: false,
            avgFlowAM3: false,
            consumptionAM3: false,
            minFlowBL: false,
            maxFlowBL: false,
            avgFlowBL: false,
            consumptionBL: false,
            minFlowBM3: false,
            maxFlowBM3: false,
            avgFlowBM3: false,
            consumptionBM3: false,
            minPressMb: false,
            maxPressMb: false,
            avgPressMb: false,
            minPressPsi: false,
            maxPressPsi: false,
            avgPressPsi: false,
            minPressBar: false,
            maxPressBar: false,
            avgPressBar: false,
            minPressMHead: false,
            maxPressMHead: false,
            avgPressMHead: false,
            cellId: false,
            freqBand: false,
            temperature: false,
            channelALoggingInterval: true,
            channelBLoggingInterval: true,
            channelCLoggingInterval: false,
            channelDLoggingInterval: false,
            lpwan: false,
            apn: false,
            channelAInputType: false,
            channelBInputType: false,
            channelCSamplingInterval: false,
            channelDSamplingInterval: false,
            channelARef: false,
            channelBRef: false,
            channelCRef: false,
            channelDRef: false,
            simVolumeAvailable: false,
            simVolumeTotal: false                                                                      
        })
    };
    CallPostAPI(CreateUrl("/api/aquaguard/bespokereport"), requestOptions)
        .then((response) => {
            if (response.status == 200) {
                return response.json()
            }
        })
        .then((data) => {
            const extractedData = data.map(d => {
                return {
                    serial: d.serial,
                    intervalA: d.channelALoggingInterval,
                    intervalB: d.channelBLoggingInterval
                }
            })
            console.log(extractedData)
        })
        .catch((err) => console.error(err))
}




export const drawGraph = (

    loggerDataArray: Array<APILoggerDetail>,
    site: number | null,
    dateChange: boolean | null,
    setLoggerSiteDetails: (siteDeetsTemp: SiteDetails[]) => void,
    setLoading: (loading: boolean) => void,
    setAshridgeDefaultInUse: (ashridgeDefault: boolean) => void,
    setAPIFailed: (apiFailed: boolean) => void,
    setAuthorised: (authorised: boolean) => void,
    startDate: Date,
    endDate: Date,
    setStartDate: (startDateProp: Date) => void,
    setVisualRange: ({ startValue, endValue }: { startValue: Date, endValue: Date }) => void,
    setHasFlow: (hasFlow: boolean) => void,
    setHasTotal: (hasTotal: boolean) => void,
    setHasConsumption: (hasConsumption: boolean) => void,
    setHasPressureChannels: (hasPressureChannels: boolean) => void,
    setShowMinMax: (displayAll: boolean) => void,
    setShowFlow: (hasFlow: boolean) => void,
    setShowPressure: (hasPressure: boolean) => void,
    setShowTotal: (hasTotal: boolean) => void,
    setShowConsumption: (hasConsumption: boolean) => void,
    setGraphData: (graphDataTemp: Readings[]) => void,
    setReadingsData: (readingsDataTemp: APIGetLoggerReadingsModel[]) => void,
    setUnitsAndValues: (unitsAndValues: GraphTemplate[]) => void,
    setCheckAlarms: (checkAlarms: boolean) => void,
    setLoggers: (loggers: APILoggerDetail[]) => void,
    setLoggersToTemplate: (loggerToTemplate: number) => void,
    setHasDigital: (hasDigitalChannel: boolean) => void,
    setShowDigital: (showDigitalChannel: boolean) => void
): void =>
{
    const siteDeetsTemp: SiteDetails[] = []

    loggerDataArray.forEach(logger => {
        if (logger.SiteName !== "Unassigned") {
            siteDeetsTemp.push({ siteRef: logger.SiteName, siteName: logger.SiteNameUserFriendly, serial: logger.Serial })
        }
    })
    setLoggerSiteDetails(siteDeetsTemp)
    setLoading(true)
    const ashridgeDefault: GraphTemplate = graphTemplateModel
    /// Ashridge default graph template
    const loggersUnitsAndValues = new Array<GraphTemplate>()

    //// Graph query in HERE

    ///call for active templates
    let companyDefault = false

    CallGetAPI(CreateUrl(`/api/aquaguard/graphTemplate?CompanyId=${sessionStorage.getItem('companyId')}`), {})


        .then(data => {
            const extractedData = data.map((item : APIGraphTemplate )=> {
                item.graphSettings = JSON.parse(item.graphSettings)

                return item
            })

            const userTemplate: GraphTemplate[] = extractedData.filter((template : GraphTemplate) => {
                return loggerDataArray.map(item => item.Serial).includes(template.serial)
            }).filter((template : GraphTemplate) => {
                const userId = sessionStorage.getItem('userId')
                if (userId) {
                    return template.userId === parseInt(userId)
                } else return null
            })

            const companyTemplate: GraphTemplate[] = extractedData.filter((template: GraphTemplate) => {
                return !template.serial && !template.userId
            })

            const userDefaultTemplate: GraphTemplate[] = extractedData.filter((template: GraphTemplate) => {
                console.log(template)
                return !template.serial && template.userId
            })
            console.log(userTemplate, companyTemplate, userDefaultTemplate)

            if (!site) {


                if (userTemplate.length > 0) {
                    // there is user templates

                    if (userTemplate.length === loggerDataArray.length) {
                        userTemplate.forEach((template: GraphTemplate) => {

                            template.graphSettings = findMissingKeys(template.graphSettings, ashridgeDefault.graphSettings)
                            //pushes new template to units and values list
                            loggersUnitsAndValues.push(template)

                        })
                    } else {
                        const numberOfNonUserTemplateToAdd = loggerDataArray.length - userTemplate.length
                        if (userDefaultTemplate.length > 0) {
                            console.log('hitting userdefault')
                            userTemplate.forEach((template: GraphTemplate) => {
                                template.graphSettings = findMissingKeys(template.graphSettings, ashridgeDefault.graphSettings)
                                loggersUnitsAndValues.push(template)
                            })
                            const filteredOutLoggersWithUserTemplate = loggerDataArray.filter(logger => !userTemplate.map((template: GraphTemplate) => template.serial).includes(logger.Serial))

                            for (let i = 0; i < numberOfNonUserTemplateToAdd; i++) {
                                const copy = deepCopyAshridgeDefault(userDefaultTemplate[0])
                                copy.graphSettings = findMissingKeys(userDefaultTemplate[0].graphSettings, ashridgeDefault.graphSettings)

                                copy.serial = filteredOutLoggersWithUserTemplate[i].Serial

                                copy.channelsAvail = 0
                                loggersUnitsAndValues.push(copy)
                                companyDefault = true
                            }
                        } else if (companyTemplate.length > 0) {
                            userTemplate.forEach((template: GraphTemplate) => {
                                template.graphSettings = findMissingKeys(template.graphSettings, ashridgeDefault.graphSettings)
                                loggersUnitsAndValues.push(template)
                            })
                            const filteredOutLoggersWithUserTemplate = loggerDataArray.filter(logger => !userTemplate.map((template: GraphTemplate) => template.serial).includes(logger.Serial))

                            for (let i = 0; i < numberOfNonUserTemplateToAdd; i++) {

                                companyTemplate[0].graphSettings = findMissingKeys(companyTemplate[0].graphSettings, ashridgeDefault.graphSettings)

                                companyTemplate[0].serial = filteredOutLoggersWithUserTemplate[i].Serial
                                companyTemplate[0].channelsAvail = 0
                                loggersUnitsAndValues.push(companyTemplate[0])
                                companyDefault = true
                            }
                        } else {
                            userTemplate.forEach((template: GraphTemplate) => {
                                template.graphSettings = findMissingKeys(template.graphSettings, ashridgeDefault.graphSettings)
                                loggersUnitsAndValues.push(template)
                            })
                            for (let i = 0; i < numberOfNonUserTemplateToAdd; i++) {
                                const newTemplate = deepCopyAshridgeDefault(ashridgeDefault)
                                const filterOutLoggersWithTemplate = loggerDataArray.filter(logger => !userTemplate.map((template: GraphTemplate) => template.serial).includes(logger.Serial))
                                newTemplate.isAshridgeDefault = true

                                newTemplate.serial = filterOutLoggersWithTemplate[i].Serial
                                newTemplate.siteId = site
                                loggersUnitsAndValues.push(newTemplate)
                            }
                        }
                    }
                } else if (userDefaultTemplate.length > 0) {
                    console.log('hottting userDefaultTemplate', loggerDataArray)
                    for (let i = 0; i < loggerDataArray.length; i++) {

                        const copy = deepCopyAshridgeDefault(userDefaultTemplate[0])

                        copy.graphSettings = findMissingKeys(copy.graphSettings, ashridgeDefault.graphSettings)
                        copy.serial = loggerDataArray[i].Serial

                        copy.channelsAvail = 0

                        loggersUnitsAndValues.push(copy)
                        companyDefault = true

                    }

                } else if (companyTemplate.length > 0) {
                    for (let i = 0; i < loggerDataArray.length; i++) {

                        const copy = deepCopyAshridgeDefault(companyTemplate[0])

                        copy.graphSettings = findMissingKeys(copy.graphSettings, ashridgeDefault.graphSettings)
                        copy.serial = loggerDataArray[i].Serial
                        copy.channelsAvail = 0

                        loggersUnitsAndValues.push(copy)
                        companyDefault = true

                    }
                } else {
                    setAshridgeDefaultInUse(true)
                    for (let i = 0; i < loggerDataArray.length; i++) {

                        const newTemplate = deepCopyAshridgeDefault(ashridgeDefault)
                        newTemplate.isAshridgeDefault = true
                        newTemplate.serial = loggerDataArray[i].Serial
                        newTemplate.siteId = site

                        loggersUnitsAndValues.push(newTemplate)

                    }
                }


            } else {

                ///if site render
                if (userTemplate.length > 0) {
                    // there is user templates

                    if (userTemplate.length === loggerDataArray.length) {
                        userTemplate.forEach((template: GraphTemplate) => {
                            template.graphSettings = findMissingKeys(template.graphSettings, ashridgeDefault.graphSettings)
                            loggersUnitsAndValues.push(template)
                        })
                    } else {
                        const numberOfNonUserTemplateToAdd = loggerDataArray.length - userTemplate.length
                        if (userDefaultTemplate.length > 0) {
                            userTemplate.forEach((template: GraphTemplate) => {
                                template.graphSettings = findMissingKeys(template.graphSettings, ashridgeDefault.graphSettings)
                                loggersUnitsAndValues.push(template)
                            })
                            const filteredOutLoggersWithUserTemplate = loggerDataArray.filter(logger => !userTemplate.map((template: GraphTemplate) => template.serial).includes(logger.Serial))
                            for (let i = 0; i < numberOfNonUserTemplateToAdd; i++) {
                                userDefaultTemplate[0].graphSettings = findMissingKeys(userDefaultTemplate[0].graphSettings, ashridgeDefault.graphSettings)
                                userDefaultTemplate[0].serial = filteredOutLoggersWithUserTemplate[i].Serial
                                userDefaultTemplate[0].channelsAvail = 0
                                loggersUnitsAndValues.push(userDefaultTemplate[0])
                                companyDefault = true
                            }
                        } else if (companyTemplate.length > 0) {
                            userTemplate.forEach((template: GraphTemplate) => {
                                template.graphSettings = findMissingKeys(template.graphSettings, ashridgeDefault.graphSettings)
                                loggersUnitsAndValues.push(template)
                            })
                            const filteredOutLoggersWithUserTemplate = loggerDataArray.filter(logger => !userTemplate.map((template: GraphTemplate) => template.serial).includes(logger.Serial))
                            for (let i = 0; i < numberOfNonUserTemplateToAdd; i++) {
                                companyTemplate[0].graphSettings = findMissingKeys(companyTemplate[0].graphSettings, ashridgeDefault.graphSettings)
                                companyTemplate[0].serial = filteredOutLoggersWithUserTemplate[i].Serial
                                companyTemplate[0].channelsAvail = 0
                                loggersUnitsAndValues.push(companyTemplate[0])
                                companyDefault = true
                            }
                        } else {
                            userTemplate.forEach((template: GraphTemplate) => {
                                template.graphSettings = findMissingKeys(template.graphSettings, ashridgeDefault.graphSettings)
                                loggersUnitsAndValues.push(template)
                            })
                            for (let i = 0; i < numberOfNonUserTemplateToAdd; i++) {
                                const newTemplate = deepCopyAshridgeDefault(ashridgeDefault)
                                const filterOutLoggersWithTemplate = loggerDataArray.filter(logger => !userTemplate.map((template: GraphTemplate) => template.serial).includes(logger.Serial))
                                newTemplate.isAshridgeDefault = true

                                newTemplate.serial = filterOutLoggersWithTemplate[i].Serial
                                newTemplate.siteId = site
                                loggersUnitsAndValues.push(newTemplate)
                            }
                        }
                    }
                } else if (userDefaultTemplate.length > 0) {
                    for (let i = 0; i < loggerDataArray.length; i++) {

                        const copy = deepCopyAshridgeDefault(userDefaultTemplate[0])
                        copy.graphSettings = findMissingKeys(copy.graphSettings, ashridgeDefault.graphSettings)
                        copy.serial = loggerDataArray[i].Serial
                        copy.channelsAvail = 0
                        loggersUnitsAndValues.push(copy)
                        companyDefault = true

                    }
                } else if (companyTemplate.length > 0) {
                    for (let i = 0; i < loggerDataArray.length; i++) {

                        const copy = deepCopyAshridgeDefault(companyTemplate[0])
                        copy.graphSettings = findMissingKeys(copy.graphSettings, ashridgeDefault.graphSettings)
                        copy.serial = loggerDataArray[i].Serial
                        copy.channelsAvail = 0
                        loggersUnitsAndValues.push(copy)
                        companyDefault = true

                    }
                } else {
                    setAshridgeDefaultInUse(true)
                    for (let i = 0; i < loggerDataArray.length; i++) {

                        const newTemplate = deepCopyAshridgeDefault(ashridgeDefault)
                        newTemplate.isAshridgeDefault = true
                        newTemplate.serial = loggerDataArray[i].Serial
                        newTemplate.siteId = site

                        loggersUnitsAndValues.push(newTemplate)

                    }
                }
            }




            loggersUnitsAndValues.forEach(unit => unit.alarms = [])

        })
        .catch((error) => {
            console.log(error);
            setAPIFailed(true)
            setAuthorised(false)
        });






    let readingsDataTemp = new Array<APIGetLoggerReadingsModel>();
    let graphDataTemp = new Array<Readings>();








    //    //get readings for the loggers here

    //    //generate array of Promises each adding the readingsData for each logger
    const promises = new Array<Promise<any>>();
    const utcOffset = sessionStorage.getItem('utcOffset')
    const offset = utcOffset ? parseInt(utcOffset.slice(1)) : 0
    
    let offsetStartDate: string | null
    let offsetEndDate: string | null
    if (utcOffset) {
        if (utcOffset.slice(0, 1) === '+') {
            offsetStartDate = moment(startDate).subtract(offset, 'hours').format("yyyy-MM-DDTHH:mm:ss");
            offsetEndDate = moment(endDate).subtract(offset, 'hours').format("yyyy-MM-DDTHH:mm:ss");
        } else if (utcOffset.slice(0, 1) === '-') {
            offsetStartDate = moment(startDate).add(offset, 'hours').format("yyyy-MM-DDTHH:mm:ss");
            offsetEndDate = moment(endDate).add(offset, 'hours').format("yyyy-MM-DDTHH:mm:ss");
        } else {
            offsetStartDate = moment(startDate).format("yyyy-MM-DDTHH:mm:ss");
            offsetEndDate = moment(endDate).format("yyyy-MM-DDTHH:mm:ss");
        }
    } else {
        offsetStartDate = moment(startDate).format("yyyy-MM-DDTHH:mm:ss")
        offsetEndDate = moment(endDate).format("yyyy-MM-DDTHH:mm:ss")
    }
    //console.log(loggerDataArray)
    //getLoggingIntervalsForLoggers(offsetStartDate, offsetEndDate, loggerDataArray)

    if (site === null) {

        loggerDataArray.map((logger) => {

            // console.log("DRAWGRAPH Push to API -> " + '/api/aquaguard/GetLogReadings?companyid=0&logger=' + logger.Serial + "&startDate=" + moment(this.state.startDate).format("yyyy-MM-DD") + "&endDate=" + moment(this.state.endDate).format("yyyy-MM-DD") + "T23:59:59");

            promises.push(
                CallGetAPI(CreateUrl(`/api/aquaguard/GetLogReadings?companyid=0&logger=${logger.Serial}&startDate=${offsetStartDate}&endDate=${offsetEndDate}`), {})

                    .then(json => {

                        readingsDataTemp = readingsDataTemp.concat(buildAPIGetLoggerReadingsModel(json));
                        readingsDataTemp.sort((a, b) => {
                            const DateA: any = a.dateStamp ? new Date(a.dateStamp) : 0
                            const DateB: any = b.dateStamp ? new Date(b.dateStamp) : 0
                            return DateA - DateB
                        })

                        if (moment(readingsDataTemp[0].dateStamp).isAfter(startDate)) {

                            
                            if (moment(readingsDataTemp[0].dateStamp).isAfter(moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }))) {
                                console.log(readingsDataTemp)
                                setStartDate(readingsDataTemp[0].dateStamp)
                                setVisualRange({
                                    startValue: readingsDataTemp[0].dateStamp ? readingsDataTemp[0].dateStamp : startDate,
                                    endValue: endDate
                                })
                            } else {
                                console.log(readingsDataTemp)
                                setStartDate(moment(readingsDataTemp[0].dateStamp).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate())
                                setVisualRange({
                                    startValue: moment(readingsDataTemp[0].dateStamp).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate(),
                                    endValue: endDate
                                })
                            }
                        }
                    })
                    .catch(function (ex) {

                        console.log(ex);
                    })
            );


        });
    }
    else {
        promises.push(
            CallGetAPI(CreateUrl('/api/aquaguard/GetLogReadingsBySite?siteId=' + site + "&startDate=" + offsetStartDate + "&endDate=" + offsetEndDate), {})
                .then(json => {

                    readingsDataTemp = readingsDataTemp.concat(buildAPIGetLoggerReadingsModel(json));

                })
                .catch(function (ex) {

                    console.log(ex);
                })
        );

    }

    Promise.all(promises).then(() => {
        loggersUnitsAndValues.forEach(data => {
            const settings = data.graphSettings
            if (settings.flowAMinState === 'default') {
                settings.flowAMinValue = Number.MAX_VALUE
            }
            if (settings.flowAMaxState === 'default') {
                settings.flowAMaxValue = Number.NEGATIVE_INFINITY
            }
            if (settings.flowATotalMinState === 'default') {
                settings.flowATotalMinValue = Number.MAX_VALUE
            }
            if (settings.flowATotalMaxState === 'default') {
                settings.flowATotalMaxValue = Number.NEGATIVE_INFINITY
            }
            if (settings.flowAConsumptionMinState === 'default') {
                settings.flowAConsumptionMinValue = Number.MAX_VALUE
            }
            if (settings.flowAConsumptionMaxState === 'default') {
                settings.flowAConsumptionMaxValue = Number.NEGATIVE_INFINITY
            }
            if (settings.flowBMinState === 'default') {
                settings.flowBMinValue = Number.MAX_VALUE
            }
            if (settings.flowBMaxState === 'default') {
                settings.flowBMaxValue = Number.NEGATIVE_INFINITY
            }
            if (settings.flowBTotalMinState === 'default') {
                settings.flowBTotalMinValue = Number.MAX_VALUE
            }
            if (settings.flowBConsumptionMinState === 'default') {
                settings.flowBConsumptionMinValue = Number.MAX_VALUE
            }
            if (settings.flowBConsumptionMaxState === 'default') {
                settings.flowBConsumptionMaxValue = Number.NEGATIVE_INFINITY
            }
            if (settings.flowBTotalMaxState === 'default') {
                settings.flowBTotalMaxValue = Number.NEGATIVE_INFINITY
            }
            if (settings.pressureCMinState === 'default') {
                settings.pressureCMinValue = Number.MAX_VALUE
            }
            if (settings.pressureCMaxState === 'default') {
                settings.pressureCMaxValue = Number.NEGATIVE_INFINITY
            }
            if (settings.pressureDMinState === 'default') {
                settings.pressureDMinValue = Number.MAX_VALUE
            }
            if (settings.pressureDMaxState === 'default') {
                settings.pressureDMaxValue = Number.NEGATIVE_INFINITY
            }
            if (settings.pressureEMinState === 'default') {
                settings.pressureEMinValue = Number.MAX_VALUE
            }
            if (settings.pressureEMaxState === 'default') {
                settings.pressureEMaxValue = Number.NEGATIVE_INFINITY
            }
        })
        const previousValueAArray: PreviousValueArray[] = []
        const previousValueBArray: PreviousValueArray[] = []
        

        loggerDataArray.forEach(logger => {
            previousValueAArray.push({ serial: logger.Serial, value: null, isZero: true })
            previousValueBArray.push({ serial: logger.Serial, value: null, isZero: true })
        })




        readingsDataTemp.sort((a, b) => {
            const dateA = a.dateStamp ? new Date(a.dateStamp).getTime() : 0
            const dateB = b.dateStamp ? new Date(b.dateStamp).getTime() : 0
            return dateA - dateB
        })


        /// manipulate readinds data
        console.log(readingsDataTemp)
        readingsDataTemp.forEach((v: APIGetLoggerReadingsModel, idx: number) => {

            if (v.dateStamp != null) {

                let multiplier = decodeFlowMultiplier(0);
                if (v.multiplier != null) {
                    multiplier = decodeFlowMultiplier(v.multiplier);

                }

                let value = v.value;
                if (value == null) {
                    value = v.value2;
                }

                const prefix = v.loggerSerial;


                //-32768 is an invalid reading for logger, so should be ignored
                // Flow is ALWAYS l/s regardless of logger units

                if (v.channelletter == 'A') {
                    if (v.units == "mm") {
                        // Treat as accumulated rainfall
                        const rec: Readings = {
                            date: adjustTime(new Date(v.dateStamp)),
                            serial: prefix,
                            ChannelLetter: 'A'
                        };
                        rec[prefix + 'Channel'] = "Reading";
                        rec[prefix + 'readingA'] = (v.difference != null && v.difference >= 0) ? v.difference * multiplier.factor : null;
                        rec[prefix + 'readingB'] = null;
                        rec[prefix + 'readingC'] = null;
                        rec[prefix + 'readingD'] = null;
                        rec[prefix + 'readingE'] = null;
                        rec[prefix + 'readingMax'] = (v.maxValue != -32768) ? v.maxValue : null;
                        rec[prefix + 'readingMin'] = (v.minValue != -32768) ? v.minValue : null;
                        rec[prefix + 'readingSet'] = null;
                        rec[prefix + 'readingClr'] = null;
                        // Sampling data
                        rec[prefix + 'readingCmin'] = null;
                        rec[prefix + 'readingCmax'] = null;
                        rec[prefix + 'readingDmin'] = null;
                        rec[prefix + 'readingDmax'] = null;
                        rec[prefix + 'readingEmin'] = null;
                        rec[prefix + 'readingEmax'] = null;
                        //unit
                        rec['unitA '] = 'mm';
                        graphDataTemp.push(rec);

                        if (value != -32768) {

                            // Expect 4 readings per hour, aggregated
                            for (let i = 0; i < loggersUnitsAndValues.length; i++) {
                                if (companyDefault) {
                                    loggersUnitsAndValues[i].channelsAvail |= 0x01

                                    if (v.difference != null && (v.difference * multiplier.factor * 4) > loggersUnitsAndValues[i].graphSettings.flowAMaxValue) {
                                        loggersUnitsAndValues[i].graphSettings.flowAMaxValue = v.difference * multiplier.factor * 4;
                                    }
                                    if (v.difference != null && v.difference >= 0 && (v.difference * multiplier.factor) < loggersUnitsAndValues[i].graphSettings.flowAMinValue) {
                                        loggersUnitsAndValues[i].graphSettings.flowAMinValue = v.difference * multiplier.factor;
                                    }
                                    if (v.difference != null && (v.difference * multiplier.factor * 4) > loggersUnitsAndValues[i].graphSettings.flowAMaxValue) {
                                        loggersUnitsAndValues[i].graphSettings.flowAMaxValue = v.difference * multiplier.factor * 4;
                                    }
                                    if (v.difference != null && v.difference >= 0 && (v.difference * multiplier.factor) < loggersUnitsAndValues[i].graphSettings.flowAMinValue) {
                                        loggersUnitsAndValues[i].graphSettings.flowAMinValue = v.difference * multiplier.factor;
                                    }
                                    if (v.units && loggersUnitsAndValues[i].graphSettings.flowAUnit == "") {
                                        loggersUnitsAndValues[i].graphSettings.flowAUnit = v.units;
                                    }

                                } else if (loggersUnitsAndValues[i].isAshridgeDefault) {
                                    loggersUnitsAndValues[i].channelsAvail |= 0x01
                                    if (v.difference != null && (v.difference * multiplier.factor * 4) > loggersUnitsAndValues[i].graphSettings.flowAMaxValue) {
                                        loggersUnitsAndValues[i].graphSettings.flowAMaxValue = v.difference * multiplier.factor * 4;
                                    }
                                    if (v.difference != null && v.difference >= 0 && (v.difference * multiplier.factor) < loggersUnitsAndValues[i].graphSettings.flowAMinValue) {
                                        loggersUnitsAndValues[i].graphSettings.flowAMinValue = v.difference * multiplier.factor;
                                    }
                                    if (v.difference != null && (v.difference * multiplier.factor * 4) > loggersUnitsAndValues[i].graphSettings.flowAMaxValue) {
                                        loggersUnitsAndValues[i].graphSettings.flowAMaxValue = v.difference * multiplier.factor * 4;
                                    }
                                    if (v.difference != null && v.difference >= 0 && (v.difference * multiplier.factor) < loggersUnitsAndValues[i].graphSettings.flowAMinValue) {
                                        loggersUnitsAndValues[i].graphSettings.flowAMinValue = v.difference * multiplier.factor;
                                    }
                                    if (v.units && loggersUnitsAndValues[i].graphSettings.flowAUnit == "") {
                                        loggersUnitsAndValues[i].graphSettings.flowAUnit = v.units;
                                    }
                                }


                                else {
                                    if (loggersUnitsAndValues[i].serial === parseInt(v.loggerSerial)) {
                                        loggersUnitsAndValues[i].channelsAvail |= 0x01
                                        if (v.difference != null && (v.difference * multiplier.factor * 4) > loggersUnitsAndValues[i].graphSettings.flowAMaxValue) {
                                            loggersUnitsAndValues[i].graphSettings.flowAMaxValue = v.difference * multiplier.factor * 4;
                                        }
                                        if (v.difference != null && v.difference >= 0 && (v.difference * multiplier.factor) < loggersUnitsAndValues[i].graphSettings.flowAMinValue) {
                                            loggersUnitsAndValues[i].graphSettings.flowAMinValue = v.difference * multiplier.factor;
                                        }
                                        if (v.difference != null && (v.difference * multiplier.factor * 4) > loggersUnitsAndValues[i].graphSettings.flowAMaxValue) {
                                            loggersUnitsAndValues[i].graphSettings.flowAMaxValue = v.difference * multiplier.factor * 4;
                                        }
                                        if (v.difference != null && v.difference >= 0 && (v.difference * multiplier.factor) < loggersUnitsAndValues[i].graphSettings.flowAMinValue) {
                                            loggersUnitsAndValues[i].graphSettings.flowAMinValue = v.difference * multiplier.factor;
                                        }
                                        if (v.units && loggersUnitsAndValues[i].graphSettings.flowAUnit == "") {
                                            loggersUnitsAndValues[i].graphSettings.flowAUnit = v.units;
                                        }
                                    }
                                }

                            }


                        }

                    } else {

                        let conversion = 1; //in what everthe unit of reading is
                        let flowConversion = 1;
                        let consumptionConversion = 1// always l/s
                        let unitsA = ""
                        let unitsAT = ""
                        let unitsAC = ""
                        for (let i = 0; i < loggersUnitsAndValues.length; i++) {
                            const l = loggersUnitsAndValues[i].graphSettings

                            if (v.channelType === 51) {
                                /// is digital channel
                                if (parseInt(prefix) === loggersUnitsAndValues[i].serial) {
                                    l.flowAIsDigital = true
                                    l.flowAUnit = 'Digital ON/OFF'
                                    l.flowATotalVisible = false
                                    l.flowAConsumptionVisible = false
                                    l.flowAGraphType = 'stepline'
                                }

                            }
                            unitsA = l.flowAUnit
                            unitsAT = l.flowATotalUnit
                            unitsAC = l.flowAConsumptionUnit
                            if (loggersUnitsAndValues[i].isAshridgeDefault) {
                                // sets unit to reading unit if not custom unit

                                // totaliser
                                unitsAT = v.units
                                l.flowATotalUnit = v.units
                                //consumption
                                unitsAC = v.units
                                l.flowAConsumptionUnit = v.units




                            }

                            if (parseInt(prefix) === loggersUnitsAndValues[i].serial) {
                                flowConversion = flowConverter(l.flowAUnit, 'l/s')
                            }

                            ///Totaliser Units

                            if (parseInt(prefix) === loggersUnitsAndValues[i].serial) {
                                if (v.units) {
                                    conversion = totalConverter(l.flowATotalUnit, v.units)

                                }
                            }
                            ///Consumption Units

                            if (parseInt(prefix) === loggersUnitsAndValues[i].serial) {
                                if (v.units) {
                                    consumptionConversion = totalConverter(l.flowAConsumptionUnit, v.units)
                                }
                            }

                        }
                        let previousValueA: number | null = null
                        if (moment(v.dateStamp).isSame(moment(v.dateStamp).startOf('day'), 'second')) {
                            previousValueAArray.forEach(item => {
                                if (item.serial === parseInt(v.loggerSerial)) {
                                    previousValueA = item.value
                                    
                                }
                            })
                        }

                        previousValueAArray.forEach(item => {
                            if (item.serial === parseInt(v.loggerSerial)) {
                                if (item.isZero && v.flowRate !== 0) {
                                    item.isZero = false
                                }
                            }
                        })



                        if (previousValueA == null) {
                            previousValueA = value
                        }

                        const consumption = (value && value != -32768 && moment(v.dateStamp).isSame(moment(v.dateStamp).startOf('day'), 'second') && previousValueA) ? value - previousValueA : null

                        const rec: Readings = {
                            date: adjustTime(new Date(v.dateStamp)),
                            serial: prefix,
                            ChannelLetter: 'A'
                        };
                        rec[prefix + 'Channel'] = "Reading";
                        rec[prefix + 'readingA'] = (value && value != -32768) ? parseFloat((value * conversion).toFixed(2)) : null
                        rec[prefix + 'consumptionA'] = (consumption != null) ? parseFloat((consumption * consumptionConversion).toFixed(2)) : null
                        rec[prefix + 'readingB'] = null;
                        rec[prefix + 'consumptionB'] = null;
                        rec[prefix + 'readingC'] = null;
                        rec[prefix + 'readingD'] = null;
                        rec[prefix + 'readingE'] = null;
                        rec[prefix + 'readingMax'] = (v.maxValue != -32768) ? v.maxValue : null;
                        rec[prefix + 'readingMin'] = (v.minValue != -32768) ? v.minValue : null;
                        rec[prefix + 'readingSet'] = null;
                        rec[prefix + 'readingClr'] = null;
                        rec[prefix + 'flowRateA'] = v.flowRate !== null ? parseFloat((v.flowRate * flowConversion).toFixed(3)) : null;
                        rec[prefix + 'readingCmin'] = null;
                        rec[prefix + 'readingCmax'] = null;
                        rec[prefix + 'readingDmin'] = null;
                        rec[prefix + 'readingDmax'] = null;
                        rec[prefix + 'readingEmin'] = null;
                        rec[prefix + 'readingEmax'] = null;
                        rec['unitA '] = unitsA
                        rec['unitAT'] = unitsAT
                        rec['unitAC'] = unitsAC

                        

                        graphDataTemp.push(rec);

                        //limits

                        if (value !== -32768) {
                            // Loop over loggersUnitsAndValues to find matching logger serials
                            for (let i = 0; i < loggersUnitsAndValues.length; i++) {

                                const l = loggersUnitsAndValues[i].graphSettings
                                if (v.flowRate && parseFloat((v.flowRate * flowConversion).toFixed(3)) > l.flowAOriginalMax) {
                                    l.flowAOriginalMax = parseFloat((v.flowRate * flowConversion).toFixed(3))
                                }
                                if (v.flowRate && parseFloat((v.flowRate * flowConversion).toFixed(3)) < l.flowAOriginalMin) {
                                    l.flowAOriginalMin = parseFloat((v.flowRate * flowConversion).toFixed(3))
                                }

                                loggersUnitsAndValues[i].channelsAvail |= 0x01
                                if (loggersUnitsAndValues[i].isAshridgeDefault || l.flowAMinState === 'default' || l.flowAMaxState === 'default') {
                                    if (parseInt(v.loggerSerial) === loggersUnitsAndValues[i].serial) {
                                        if (v.flowRate != null) {
                                            if (l.flowAMaxState === 'default') {

                                                if (parseFloat((v.flowRate * flowConversion).toFixed(3)) > l.flowAMaxValue) {
                                                    l.flowAMaxValue = parseFloat((v.flowRate * flowConversion).toFixed(3));
                                                }
                                            }
                                            if (l.flowAMinState === 'default') {
                                                if (parseFloat((v.flowRate * flowConversion).toFixed(3)) < l.flowAMinValue) {
                                                    l.flowAMinValue = parseFloat((v.flowRate * flowConversion).toFixed(3));
                                                }
                                            }
                                        }
                                    }
                                }

                                ///totals
                                if (loggersUnitsAndValues[i].isAshridgeDefault || l.flowATotalMinState === 'default' || l.flowATotalMaxState === 'default') {
                                    if (parseInt(v.loggerSerial) === loggersUnitsAndValues[i].serial) {
                                        if (v.value != null) {
                                            if (l.flowATotalMaxState === 'default') {
                                                if (parseFloat((v.value * conversion).toFixed(2)) > l.flowATotalMaxValue) {
                                                    l.flowATotalMaxValue = parseFloat((v.value * conversion).toFixed(2));
                                                }
                                            }
                                            if (l.flowATotalMinState === 'default') {
                                                if (parseFloat((v.value * conversion).toFixed(2)) < l.flowATotalMinValue) {
                                                    l.flowATotalMinValue = parseFloat((v.value * conversion).toFixed(2));
                                                }
                                            }
                                        }
                                    }
                                }

                                ///Consumptions
                                if (loggersUnitsAndValues[i].isAshridgeDefault || l.flowAConsumptionMinState === 'default' || l.flowAConsumptionMaxState === 'default') {
                                    if (parseInt(v.loggerSerial) === loggersUnitsAndValues[i].serial) {
                                        if (consumption != null) {

                                            if (l.flowAConsumptionMaxState === 'default') {
                                                if (parseFloat((consumption * consumptionConversion).toFixed(2)) > l.flowAConsumptionMaxValue) {
                                                    l.flowAConsumptionMaxValue = parseFloat((consumption * consumptionConversion).toFixed(2));
                                                }
                                            }
                                            if (l.flowAConsumptionMinState === 'default') {
                                                l.flowAConsumptionMinValue = 0;
                                            }
                                        }
                                    }
                                }

                            }
                            if (moment(v.dateStamp).isSame(moment(v.dateStamp).startOf('day'), 'second')) {
                                previousValueAArray.forEach(item => {
                                    if (item.serial === parseInt(v.loggerSerial)) {

                                        item.value = value
                                    }
                                })
                            }
                        }
                        console.log(rec['73668flowRateA'], loggersUnitsAndValues)
                    }
                }

                if (v.channelletter == 'B') {
                    let conversion = 1; //in what everthe unit of reading is
                    let flowConversion = 1; // always l/s
                    let consumptionConversion = 1
                    let unitsB = ""
                    let unitsBT = ""
                    let unitsBC = ""
                    for (let i = 0; i < loggersUnitsAndValues.length; i++) {
                        const l = loggersUnitsAndValues[i].graphSettings

                        if (v.channelType === 51) {
                            /// is digital channel
                            if (parseInt(prefix) === loggersUnitsAndValues[i].serial) {
                                l.flowBIsDigital = true
                                l.flowBUnit = 'Digital ON/OFF'
                                l.flowBTotalVisible = false
                                l.flowBConsumptionVisible = false
                                l.flowBGraphType = 'stepline'
                            }

                        }
                        unitsB = l.flowBUnit
                        unitsBT = l.flowBTotalUnit
                        if (loggersUnitsAndValues[i].isAshridgeDefault) {

                            unitsBT = v.units
                            l.flowBTotalUnit = v.units
                            unitsBC = v.units
                            l.flowBConsumptionUnit = v.units
                        } else if (!companyDefault) {
                            flowConversion = flowConverter(l.flowBUnit, 'l/s')
                        } else {
                            flowConversion = flowConverter(l.flowBUnit, 'l/s')
                        }

                        //totaliser units

                        if (parseInt(prefix) === loggersUnitsAndValues[i].serial) {
                            if (v.units) {
                                conversion = totalConverter(l.flowBTotalUnit, v.units)
                            }
                        }

                        ///Consumption Units

                        if (parseInt(prefix) === loggersUnitsAndValues[i].serial) {
                            if (v.units) {
                                consumptionConversion = totalConverter(l.flowAConsumptionUnit, v.units)
                            }
                        }

                        if (v.units) {
                            consumptionConversion = totalConverter(l.flowAConsumptionUnit, v.units)
                        }

                    }
                    let previousValueB: number | null = null
                    if (moment(v.dateStamp).isSame(moment(v.dateStamp).startOf('day'), 'second')) {
                        previousValueBArray.forEach(item => {
                            if (item.serial === parseInt(v.loggerSerial)) {
                                previousValueB = item.value
                            }
                        })
                    }

                    previousValueBArray.forEach(item => {
                        if (item.serial === parseInt(v.loggerSerial)) {
                            if (item.isZero && v.flowRate !== 0) {
                                item.isZero = false
                            }
                        }
                    })

                    if (previousValueB == null) {
                        previousValueB = value
                    }

                    const consumption = (value && previousValueB && value != -32768 && moment(v.dateStamp).isSame(moment(v.dateStamp).startOf('day'), 'second') && previousValueB) ? value - previousValueB : null
                    const rec: Readings = {
                        date: adjustTime(new Date(v.dateStamp)),
                        serial: prefix,
                        ChannelLetter: 'B'
                    };
                    rec[prefix + 'Channel'] = "Reading";
                    rec[prefix + 'readingA'] = null;
                    rec[prefix + 'consumptionA'] = null;
                    rec[prefix + 'readingB'] = (value != -32768 && value) ? parseFloat((value * conversion).toFixed(2)) : null;
                    rec[prefix + 'consumptionB'] = (consumption != null) ? parseFloat((consumption * consumptionConversion).toFixed(2)) : null;
                    rec[prefix + 'readingC'] = null;
                    rec[prefix + 'readingD'] = null;
                    rec[prefix + 'readingE'] = null;
                    rec[prefix + 'readingSet'] = null;
                    rec[prefix + 'readingClr'] = null;
                    rec[prefix + 'flowRateB'] = v.flowRate !== null ? parseFloat((v.flowRate * flowConversion).toFixed(3)) : null
                    rec[prefix + 'readingCmin'] = null;
                    rec[prefix + 'readingCmax'] = null;
                    rec[prefix + 'readingDmin'] = null;
                    rec[prefix + 'readingDmax'] = null;
                    rec[prefix + 'readingEmin'] = null;
                    rec[prefix + 'readingEmax'] = null;
                    rec['unitB '] = unitsB
                    rec['unitBT'] = unitsBT
                    rec['unitBC'] = unitsBC


                    
                    graphDataTemp.push(rec);

                    //limits

                    if (value !== -32768) {
                        // Loop over loggersUnitsAndValues to find matching logger serials
                        for (let i = 0; i < loggersUnitsAndValues.length; i++) {

                            const l = loggersUnitsAndValues[i].graphSettings
                            if (v.flowRate && parseFloat((v.flowRate * flowConversion).toFixed(3)) > l.flowBOriginalMax) {
                                l.flowBOriginalMax = parseFloat((v.flowRate * flowConversion).toFixed(3))
                            }
                            if (v.flowRate && parseFloat((v.flowRate * flowConversion).toFixed(3)) < l.flowBOriginalMin) {
                                l.flowBOriginalMin = parseFloat((v.flowRate * flowConversion).toFixed(3))
                            }
                            if (loggersUnitsAndValues[i].isAshridgeDefault || l.flowBMinState === 'default' || l.flowBMaxState === 'default') {
                                if (parseInt(v.loggerSerial) === loggersUnitsAndValues[i].serial) {
                                    if (v.flowRate != null) {


                                        if (l.flowBMaxState === 'default') {
                                            if (parseFloat((v.flowRate * flowConversion).toFixed(3)) > l.flowBMaxValue) {
                                                l.flowBMaxValue = parseFloat((v.flowRate * flowConversion).toFixed(3));
                                            }
                                        }
                                        if (l.flowBMinState === 'default') {
                                            if (parseFloat((v.flowRate * flowConversion).toFixed(3)) < l.flowBMinValue) {
                                                l.flowBMinValue = parseFloat((v.flowRate * flowConversion).toFixed(3));
                                            }

                                        }
                                    }
                                }
                                if (parseInt(v.loggerSerial) === loggersUnitsAndValues[i].serial) {
                                    loggersUnitsAndValues[i].channelsAvail |= 0x02
                                }
                            }
                            ///totals
                            if (loggersUnitsAndValues[i].isAshridgeDefault || l.flowBTotalMinState === 'default' || l.flowBTotalMaxState === 'default') {
                                if (parseInt(v.loggerSerial) === loggersUnitsAndValues[i].serial) {
                                    if (v.value != null) {
                                        if (l.flowBTotalMaxState === 'default') {
                                            if (value && value > l.flowBTotalMaxValue) {
                                                l.flowBTotalMaxValue = parseFloat((value * conversion).toFixed(2));
                                            }
                                        }
                                        if (l.flowBTotalMinState === 'default') {
                                            if (value && value < l.flowBTotalMinValue) {
                                                l.flowBTotalMinValue = parseFloat((value * conversion).toFixed(2));
                                            }
                                        }
                                    }
                                }
                            }
                            ///Consumptions
                            if (loggersUnitsAndValues[i].isAshridgeDefault || l.flowBConsumptionMinState === 'default' || l.flowBConsumptionMaxState === 'default') {
                                if (parseInt(v.loggerSerial) === loggersUnitsAndValues[i].serial) {
                                    if (consumption != null) {
                                        if (l.flowBConsumptionMaxState === 'default') {
                                            if (consumption > l.flowBConsumptionMaxValue) {
                                                l.flowBConsumptionMaxValue = parseFloat((consumption * consumptionConversion).toFixed(2));
                                            }
                                        }
                                        if (l.flowBConsumptionMinState === 'default') {
                                            l.flowBConsumptionMinValue = 0;
                                        }
                                    }
                                }
                            }
                        }
                        if (moment(v.dateStamp).isSame(moment(v.dateStamp).startOf('day'), 'second')) {
                            previousValueBArray.forEach(item => {
                                if (item.serial === parseInt(v.loggerSerial)) {
                                    item.value = value
                                }
                            })
                        }
                    }
                }

                if (v.channelletter == 'C') {
                    let conversion: number | null = 1;

                    let unitsC = ""

                    for (let i = 0; i < loggersUnitsAndValues.length; i++) {
                        const l = loggersUnitsAndValues[i].graphSettings

                        unitsC = l.pressureCUnit
                        l.pressureCOriginalUnit = v.units
                        if (loggersUnitsAndValues[i].isAshridgeDefault) {
                            unitsC = v.units
                            l.pressureCUnit = v.units
                        } else if (!companyDefault) {
                            if (parseInt(prefix) === loggersUnitsAndValues[i].serial) {
                                if (v.units) {
                                    conversion = pressureConverter(l.pressureCUnit, v.units)
                                }
                            }
                        } else {
                            if (v.units) {
                                conversion = pressureConverter(l.pressureCUnit, v.units)
                            }
                        }
                        if (conversion === null) {
                            conversion = 1
                            unitsC = v.units
                            l.pressureCIsNotPressure = true
                        }
                    }

                    const rec: Readings = {
                        date: adjustTime(new Date(v.dateStamp)),
                        serial: prefix,
                        ChannelLetter: 'C'
                    };
                    rec[prefix + 'Channel'] = "Reading";
                    rec[prefix + 'readingA'] = null;
                    rec[prefix + 'readingB'] = null;
                    rec[prefix + 'readingC'] = (value && value != -32768) ? parseFloat((value * conversion).toFixed(3)) : null;
                    rec[prefix + 'readingD'] = null;
                    rec[prefix + 'readingE'] = null;
                    rec[prefix + 'readingSet'] = null;
                    rec[prefix + 'readingClr'] = null;
                    rec[prefix + 'readingCmin'] = (v.minValue && v.minValue != -32768) ? parseFloat((v.minValue * conversion).toFixed(3)) : null;
                    rec[prefix + 'readingCmax'] = (v.maxValue && v.maxValue != -32768) ? parseFloat((v.maxValue * conversion).toFixed(3)) : null;
                    rec[prefix + 'readingDmin'] = null;
                    rec[prefix + 'readingDmax'] = null;
                    rec[prefix + 'readingEmin'] = null;
                    rec[prefix + 'readingEmax'] = null;
                    rec['unitC '] = unitsC
                    graphDataTemp.push(rec);

                    if (value !== -32768) {
                        // Loop over loggersUnitsAndValues to find matching logger serials
                        for (let i = 0; i < loggersUnitsAndValues.length; i++) {

                            const l = loggersUnitsAndValues[i].graphSettings
                            if (v.value && v.value * conversion > l.pressureCOriginalMax) {
                                l.pressureCOriginalMax = parseFloat((v.value * conversion).toFixed(3))
                            }
                            if (v.value && v.value * conversion < l.pressureCOriginalMin) {
                                l.pressureCOriginalMin = parseFloat((v.value * conversion).toFixed(3))
                            }
                            if (parseInt(v.loggerSerial) === loggersUnitsAndValues[i].serial) {

                                loggersUnitsAndValues[i].channelsAvail |= 0x04

                                let inputValue = value
                                if (l.pressureCValueAs === 'max') {
                                    inputValue = (v.maxValue && v.maxValue != -32768) ? parseFloat((v.maxValue * conversion).toFixed(3)) : null
                                }
                                if (l.pressureCValueAs === 'min') {
                                    inputValue = (v.minValue && v.minValue != -32768) ? parseFloat((v.minValue * conversion).toFixed(3)) : null
                                }
                                if (!v.minValue && !v.maxValue) {
                                    l.pressureCAllowMinMax = false
                                    l.pressureCDisplayAll = false
                                }
                                if (loggersUnitsAndValues[i].isAshridgeDefault || l.pressureCMinState === 'default' || l.pressureCMaxState === 'default') {
                                    if (inputValue != null) {
                                        if (l.pressureCDisplayAll && v.maxValue && v.minValue) {
                                            if (l.pressureCMaxState === 'default' && parseFloat((v.maxValue * conversion).toFixed(3)) > l.pressureCMaxValue) {
                                                l.pressureCMaxValue = parseFloat((v.maxValue * conversion).toFixed(3))
                                            }
                                            if (l.pressureCMinState === 'default' && parseFloat((v.minValue * conversion).toFixed(3)) < l.pressureCMinValue) {
                                                l.pressureCMinValue = parseFloat((v.minValue * conversion).toFixed(3))
                                            }
                                        } else {
                                            if (l.pressureCMaxState === 'default' && parseFloat((inputValue * conversion).toFixed(3)) > l.pressureCMaxValue) {
                                                l.pressureCMaxValue = parseFloat((inputValue * conversion).toFixed(3))
                                            }
                                            if (l.pressureCMinState === 'default' && parseFloat((inputValue * conversion).toFixed(3)) < l.pressureCMinValue) {
                                                l.pressureCMinValue = parseFloat((inputValue * conversion).toFixed(3))
                                            }
                                        }

                                    }
                                }
                            }
                        }
                    }
                }

                if (v.channelletter == 'D') {
                    let conversion = 1;

                    let unitsD = ""
                    for (let i = 0; i < loggersUnitsAndValues.length; i++) {
                        const l = loggersUnitsAndValues[i].graphSettings
                        l.pressureDOriginalUnit = v.units
                        unitsD = l.pressureDUnit
                        if (loggersUnitsAndValues[i].isAshridgeDefault) {

                            unitsD = v.units
                            l.pressureDUnit = v.units

                        } else if (!companyDefault) {
                            if (parseInt(prefix) === loggersUnitsAndValues[i].serial) {
                                if (v.units) {
                                    conversion = pressureConverter(l.pressureDUnit, v.units)
                                }
                            }
                        } else {
                            if (v.units) {
                                conversion = pressureConverter(l.pressureDUnit, v.units)
                            }
                        }
                        if (conversion === null) {
                            conversion = 1
                            unitsD = v.units
                            l.pressureDIsNotPressure = true
                        }
                    }


                    const rec: Readings = {
                        date: adjustTime(new Date(v.dateStamp)),
                        serial: prefix,
                        ChannelLetter: 'D'
                    };
                    rec[prefix + 'Channel'] = "Reading";
                    rec[prefix + 'readingA'] = null;
                    rec[prefix + 'readingB'] = null;
                    rec[prefix + 'readingC'] = null;
                    rec[prefix + 'readingD'] = (value && value != -32768) ? parseFloat((value * conversion).toFixed(3)) : null;
                    rec[prefix + 'readingE'] = null;
                    rec[prefix + 'readingSet'] = null;
                    rec[prefix + 'readingClr'] = null;
                    rec[prefix + 'readingCmin'] = null;
                    rec[prefix + 'readingCmax'] = null;
                    rec[prefix + 'readingDmin'] = (v.minValue && v.minValue != -32768) ? parseFloat((v.minValue * conversion).toFixed(3)) : null;
                    rec[prefix + 'readingDmax'] = (v.maxValue && v.maxValue != -32768) ? parseFloat((v.maxValue * conversion).toFixed(3)) : null;
                    rec[prefix + 'readingEmin'] = null;
                    rec[prefix + 'readingEmax'] = null;
                    rec['unitD '] = unitsD

                    graphDataTemp.push(rec);

                    if (value !== -32768) {
                        // Loop over loggersUnitsAndValues to find matching logger serials
                        for (let i = 0; i < loggersUnitsAndValues.length; i++) {

                            const l = loggersUnitsAndValues[i].graphSettings
                            if (v.value && parseFloat((v.value * conversion).toFixed(3)) > l.pressureDOriginalMax) {
                                l.pressureDOriginalMax = parseFloat((v.value * conversion).toFixed(3))
                            }
                            if (v.value && parseFloat((v.value * conversion).toFixed(3)) < l.pressureDOriginalMin) {
                                l.pressureDOriginalMin = parseFloat((v.value * conversion).toFixed(3))
                            }
                            if (parseInt(v.loggerSerial) === loggersUnitsAndValues[i].serial) {
                                loggersUnitsAndValues[i].channelsAvail |= 0x08
                                let inputValue = value
                                if (l.pressureDValueAs === 'max') {
                                    inputValue = (v.maxValue && v.maxValue != -32768) ? parseFloat((v.maxValue * conversion).toFixed(3)) : null;
                                }
                                if (l.pressureDValueAs === 'min') {
                                    inputValue = (v.minValue && v.minValue != -32768) ? parseFloat((v.minValue * conversion).toFixed(3)) : null;
                                }
                                if (!v.minValue && !v.maxValue) {
                                    l.pressureDAllowMinMax = false
                                    l.pressureDDisplayAll = false
                                }
                                if (loggersUnitsAndValues[i].isAshridgeDefault || l.pressureDMinState === 'default' || l.pressureDMaxState === 'default') {
                                    if (inputValue != null) {
                                        if (l.pressureDDisplayAll && v.maxValue && v.minValue) {
                                            if (l.pressureCMaxState === 'default' && parseFloat((v.maxValue * conversion).toFixed(3)) > l.pressureDMaxValue) {
                                                l.pressureDMaxValue = parseFloat((v.maxValue * conversion).toFixed(3))
                                            }
                                            if (l.pressureCMinState === 'default' && parseFloat((v.minValue * conversion).toFixed(3)) < l.pressureDMinValue) {
                                                l.pressureDMinValue = parseFloat((v.minValue * conversion).toFixed(3))
                                            }
                                        } else {
                                            if (l.pressureCMaxState === 'default' && parseFloat((inputValue * conversion).toFixed(3)) > l.pressureDMaxValue) {
                                                l.pressureDMaxValue = parseFloat((inputValue * conversion).toFixed(3))
                                            }
                                            if (l.pressureCMinState === 'default' && parseFloat((inputValue * conversion).toFixed(3)) < l.pressureDMinValue) {
                                                l.pressureDMinValue = parseFloat((inputValue * conversion).toFixed(3))
                                            }
                                        }

                                    }
                                }
                            }
                        }
                    }

                }
                if (v.channelletter == 'E') {
                    let conversion = 1;

                    let unitsE = ""
                    for (let i = 0; i < loggersUnitsAndValues.length; i++) {

                        const l = loggersUnitsAndValues[i].graphSettings
                        l.pressureEOriginalUnit = v.units
                        unitsE = l.pressureEUnit
                        if (loggersUnitsAndValues[i].isAshridgeDefault) {

                            unitsE = v.units
                            l.pressureEUnit = v.units

                        } else if (!companyDefault) {
                            if (v.units === 'psi' || v.units === 'mH2O' || v.units === 'mwg' || v.units === 'mb' || v.units === 'bar') {
                                if (parseInt(prefix) === loggersUnitsAndValues[i].serial) {
                                    if (v.units) {
                                        conversion = pressureConverter(l.pressureEUnit, v.units)
                                    }
                                }
                            }
                        } else {
                            if (v.units) {
                                if (v.units === 'psi' || v.units === 'mH2O' || v.units === 'mwg' || v.units === 'mb' || v.units === 'bar') {
                                    conversion = pressureConverter(l.pressureEUnit, v.units)
                                } else {
                                    unitsE = v.units
                                }
                            }
                        }


                        if (conversion === null) {
                            conversion = 1
                            unitsE = v.units
                            l.pressureEIsNotPressure = true
                        }

                    }


                    const rec: Readings = {
                        date: adjustTime(new Date(v.dateStamp)),
                        serial: prefix,
                        ChannelLetter: 'E'
                    };
                    rec[prefix + 'Channel'] = "Reading";
                    rec[prefix + 'readingA'] = null;
                    rec[prefix + 'readingB'] = null;
                    rec[prefix + 'readingC'] = null;
                    rec[prefix + 'readingD'] = null;
                    rec[prefix + 'readingE'] = (value && value != -32768) ? parseFloat((value * conversion).toFixed(3)) : null;
                    rec[prefix + 'readingSet'] = null;
                    rec[prefix + 'readingClr'] = null;
                    rec[prefix + 'readingCmin'] = null;
                    rec[prefix + 'readingCmax'] = null;
                    rec[prefix + 'readingDmin'] = null;
                    rec[prefix + 'readingDmax'] = null;
                    rec[prefix + 'readingEmin'] = (v.minValue && v.minValue != -32768) ? parseFloat((v.minValue * conversion).toFixed(3)) : null;
                    rec[prefix + 'readingEmax'] = (v.maxValue && v.maxValue != -32768) ? parseFloat((v.maxValue * conversion).toFixed(3)) : null;
                    rec['unitE '] = unitsE
                    graphDataTemp.push(rec);

                    if (value !== -32768 && value) {
                        // Loop over loggersUnitsAndValues to find matching logger serials
                        for (let i = 0; i < loggersUnitsAndValues.length; i++) {

                            const l = loggersUnitsAndValues[i].graphSettings
                            if (v.value && parseFloat((v.value * conversion).toFixed(3)) > l.pressureEOriginalMax) {
                                l.pressureEOriginalMax = parseFloat((v.value * conversion).toFixed(3))
                            }
                            if (v.value && parseFloat((v.value * conversion).toFixed(3)) < l.pressureEOriginalMin) {
                                l.pressureEOriginalMin = parseFloat((v.value * conversion).toFixed(3))
                            }
                            if (parseInt(v.loggerSerial) === loggersUnitsAndValues[i].serial) {
                                loggersUnitsAndValues[i].channelsAvail |= 0x10
                                let inputValue = value

                                if (l.pressureEValueAs === 'max' && v.maxValue) {
                                    inputValue = parseFloat((v.maxValue * conversion).toFixed(3))
                                }
                                if (l.pressureEValueAs === 'min' && v.minValue) {
                                    inputValue = parseFloat((v.minValue * conversion).toFixed(3))
                                }
                                if (!v.minValue && !v.maxValue) {
                                    l.pressureEAllowMinMax = false
                                    l.pressureEDisplayAll = false
                                }
                                if (loggersUnitsAndValues[i].isAshridgeDefault || l.pressureEMinState === 'default' || l.pressureEMaxState === 'default') {
                                    if (inputValue != null) {
                                        if (l.pressureEDisplayAll && v.maxValue && v.minValue) {
                                            if (parseFloat((v.maxValue * conversion).toFixed(3)) > l.pressureEMaxValue) {
                                                l.pressureEMaxValue = parseFloat((v.maxValue * conversion).toFixed(3))
                                            }
                                            if (parseFloat((v.minValue * conversion).toFixed(3)) < l.pressureEMinValue) {
                                                l.pressureEMinValue = parseFloat((v.minValue * conversion).toFixed(3))
                                            }
                                        } else {
                                            if (parseFloat((inputValue * conversion).toFixed(3)) > l.pressureEMaxValue) {
                                                l.pressureEMaxValue = parseFloat((inputValue * conversion).toFixed(3))
                                            }
                                            if (parseFloat((inputValue * conversion).toFixed(3)) < l.pressureEMinValue) {
                                                l.pressureEMinValue = parseFloat((inputValue * conversion).toFixed(3))
                                            }
                                        }

                                    }
                                }
                            }
                        }
                    }
                }
            }


        })

        



        for (let i = 0; i < loggersUnitsAndValues.length; i++) {

            const l = loggersUnitsAndValues[i].graphSettings
            const chan:number = loggersUnitsAndValues[i].channelsAvail
            if (l.flowAMinValue == Number.MAX_VALUE) {
                if (!(chan & 0x01)) {
                    l.flowAMinValue = l.flowAMaxValue;
                }
            }
            if (l.flowBMinValue == Number.MAX_VALUE) {
                if (!(chan & 0x02)) {
                    l.flowBMinValue = l.flowBMaxValue;
                }
            }
            if (l.pressureCMinValue == Number.MAX_VALUE) {
                if (!(chan & 0x04)) {
                    l.pressureCMinValue = l.pressureCMaxValue;
                }
            }
            if (l.pressureDMinValue == Number.MAX_VALUE) {
                if (!(chan & 0x08)) {
                    l.pressureDMinValue = l.pressureDMaxValue;
                }
            }
            if (l.pressureEMinValue == Number.MAX_VALUE) {
                if (!(chan & 0x10)) {

                    l.pressureEMinValue = l.pressureEMaxValue;
                }
            }
            if (l.flowAMaxValue === Number.NEGATIVE_INFINITY) {
                l.flowAVisible = false
            }
            if (l.flowAConsumptionMaxValue === Number.NEGATIVE_INFINITY) {
                l.flowAConsumptionVisible = false
            }
            if (l.flowATotalMaxValue === Number.NEGATIVE_INFINITY) {
                l.flowATotalVisible = false
            }
            if (l.flowBMaxValue === Number.NEGATIVE_INFINITY) {
                l.flowBVisible = false
            }
            if (l.flowBConsumptionMaxValue === Number.NEGATIVE_INFINITY) {
                l.flowBConsumptionVisible = false
            }
            if (l.flowBTotalMaxValue === Number.NEGATIVE_INFINITY) {
                l.flowBTotalVisible = false
            }
            console.log(previousValueAArray)
            previousValueAArray.forEach(d => {
                if (d.serial === loggersUnitsAndValues[i].serial) {
                    if (d.isZero) {
                        l.flowAMinValue = -1
                        l.flowAMaxValue = 1
                        l.flowAZeroFlow = true
                    }
                }
            })

            previousValueBArray.forEach(d => {
                if (d.serial === loggersUnitsAndValues[i].serial) {
                    if (d.isZero) {
                        l.flowBMinValue = -1
                        l.flowBMaxValue = 1
                        l.flowBZeroFlow = true
                    }
                }
            })
        }


        for (let i = 0; i < loggersUnitsAndValues.length; i++) {

            const data = loggersUnitsAndValues[i].graphSettings
            if (data.flowATotalPerDay || data.flowBTotalPerDay) {

                const graphDataClone = [...graphDataTemp]

                if (data.flowATotalPerDay) {
                    graphDataClone.map(item => {
                        const serial = Object.keys(item)[1].slice(0, Object.keys(item)[1].indexOf('Chan'))
                        if (Object.keys(item).some(key =>
                            key.includes('readingA') && item[key] !== null && !moment(item.date).isSame(moment(item.date).startOf('day')))) {
                            item[`${serial}readingA`] = null
                            return item
                        }
                        else {
                            return item
                        }
                    })


                }
                if (data.flowBTotalPerDay) {
                    graphDataClone.map(item => {
                        const serial = Object.keys(item)[1].slice(0, Object.keys(item)[1].indexOf('Chan'))
                        if (Object.keys(item).some(key =>
                            key.includes('readingB') && item[key] !== null && !moment(item.date).isSame(moment(item.date).startOf('day')))) {
                            item[`${serial}readingB`] = null
                            return item
                        }
                        else {
                            return item
                        }
                    })


                }


                graphDataTemp = graphDataClone
            }
        }






        graphDataTemp.sort((a, b) => a.date.getTime() - b.date.getTime());

        


        let showFlowTemp = false
        let showPressureTemp = false
        let showTotalTemp = false
        let showConsumptionTemp = false
        let showDigitalTemp = false
        let displayAll = false


        loggersUnitsAndValues.forEach(item => {
            const i = item.graphSettings
            const channels = item.channelsAvail

            const channelA = 0x01
            const channelB = 0x02
            const channelC = 0x04
            const channelD = 0x08
            const channelE = 0x10

            if (channels & (channelA || channelB)) {

                if (i.flowAIsDigital) {
                    setHasDigital(true)
                } else {
                    setHasFlow(true)
                }

                if (i.flowAVisible) {
                    if (i.flowAIsDigital) {
                        showDigitalTemp = true
                    } else {
                        showFlowTemp = true
                    }
                }
                if (i.flowBVisible && i.flowBMaxValue) {
                    if (i.flowBIsDigital) {
                        showDigitalTemp = true
                    } else {
                        showFlowTemp = true
                    }
                    
                }
            }
            if (channels & (channelC | channelD | channelE)) {
                setHasPressureChannels(true)

                if (i.pressureCVisible) {
                    showPressureTemp = true
                }
                if (i.pressureDVisible && channels > 8) {
                    showPressureTemp = true
                }
                if (i.pressureEVisible && channels > 16) {
                    showPressureTemp = true
                }

            }

            if (i.flowATotalVisible && channels & channelA) {

                setHasTotal(true)
                showTotalTemp = true
            }
            if (i.flowBTotalVisible && i.flowBMaxValue && channels & channelB) {
                showTotalTemp = true
            }

            if (i.flowAConsumptionVisible && channels & channelA) {

                setHasConsumption(true)
                showConsumptionTemp = true
            }
            if (i.flowBConsumptionVisible && channels & channelB) {
                showConsumptionTemp = true
            }
        })


        if (loggersUnitsAndValues.length === 1) {
            const l = loggersUnitsAndValues[0]
            if (l.channelsAvail & 0x04 && l.graphSettings.pressureCDisplayAll) {
                displayAll = true
            } else if (l.channelsAvail & 0x08 && l.graphSettings.pressureDDisplayAll) {
                displayAll = true
            } else if (l.channelsAvail & 0x10 && l.graphSettings.pressureEDisplayAll) {
                displayAll = true
            }
        }

        setShowMinMax(displayAll)
        setShowFlow(showFlowTemp)
        setShowPressure(showPressureTemp)
        setShowTotal(showTotalTemp)
        setShowConsumption(showConsumptionTemp)
        setShowDigital(showDigitalTemp)
        setGraphData(graphDataTemp)
        setReadingsData(readingsDataTemp)
        //units set
        setUnitsAndValues(loggersUnitsAndValues)
        setCheckAlarms(true)

        setLoggers(loggerDataArray)
        //console.log(loggerDataArray[0].Serial)
        if (graphDataTemp.length > 0 && loggerDataArray[0].Serial) {
            setLoggersToTemplate(loggerDataArray[0].Serial)
        }
        setLoading(false)
    })


}